import { Injectable } from "@angular/core";
import { State, Action, StateContext, Selector } from "@ngxs/store";
import {
  GetClientId,
  GetOrganizationUnitId,
  GetTenantId,
  Login,
  SelectedDistributionLane,
  SetConnectionId,
  SetDistributionLaneId,
  SetTenant,
  SetTenantId,
  ValidateJobTerminals
} from "./planning-portal-global.actions";
import { Authorize } from "planning-portal-library/src/lib/core/domain";
import { Tenant } from "planning-portal-library/src/lib/core/domain/models/tenant";

export class PlanningPortalGlobalStateModel {
  tenantId: string | undefined;
  clientId: string | undefined;
  connectionId: string | undefined;
  organizationUnitId: string | undefined;
  subscriptionKeyInterceptor: string | undefined;
  selectedDistributionLane: string[] | undefined;
  distributionLaneId: string | undefined;
  authorize: Authorize | undefined; 
  tenant : Tenant | undefined;
  validateJobTerminals : boolean | undefined;
}

const defaults = {
  tenantId: "981CEFC1-DECC-403E-8D0B-466E0967593C".toLocaleLowerCase(),
  clientId: "bk",
  connectionId: "test_connection",
  organizationUnitId: "781CEFC1-DECC-403E-8D0B-466E0967593C",
  subscriptionKeyInterceptor: "dd98790b31c04f13b3e4b1a22c93232e",
  selectedDistributionLane: undefined,
  distributionLaneId: undefined,
  authorize: undefined,
  tenant : undefined,
  validateJobTerminals : undefined
};

@State<PlanningPortalGlobalStateModel>({
  name: "planningPortalGlobal",
  defaults
})
@Injectable()
export class PlanningPortalGlobalState {

  @Action(GetTenantId)
  getTenantId(ctx: StateContext<PlanningPortalGlobalStateModel>) {
    ctx.setState({ ...ctx.getState() });
  }

  @Action(GetClientId)
  getClientId(ctx: StateContext<PlanningPortalGlobalStateModel>) {
    ctx.setState({ ...ctx.getState() });
  }

  @Action(GetOrganizationUnitId)
  getOrganizationUnitId(ctx: StateContext<PlanningPortalGlobalStateModel>) {
    ctx.setState({ ...ctx.getState() });
  }

  @Action(SetConnectionId)
  setConnectionId(
    ctx: StateContext<PlanningPortalGlobalStateModel>,
    { payload }: SetConnectionId
  ) {
    if (payload) {
      ctx.setState({ ...ctx.getState(), connectionId: payload });
    } else {
      ctx.setState({ ...ctx.getState() });
    }
  }

  @Action(SelectedDistributionLane)
  selectedDistributionLane(
    ctx: StateContext<PlanningPortalGlobalStateModel>,
    { payload }: SelectedDistributionLane
  ) {
    ctx.setState({ ...ctx.getState(), selectedDistributionLane: payload });
  }

  @Action(SetDistributionLaneId)
  setDistributionLaneId(
    ctx: StateContext<PlanningPortalGlobalStateModel>,
    { payload }: SetDistributionLaneId
  ) {
    ctx.setState({ ...ctx.getState(), distributionLaneId: payload });
  }

  @Action(Login)
  login(ctx: StateContext<PlanningPortalGlobalStateModel>, { payload }: Login) {
    ctx.setState({ ...ctx.getState(), authorize: payload });
  }

  @Action(SetTenantId)
  SetTenantId(ctx: StateContext<PlanningPortalGlobalStateModel>, { payload }: SetTenantId) {
    ctx.setState({ ...ctx.getState(), tenantId: payload });
  }
  
  @Action(SetTenant)
  SetTenant(ctx: StateContext<PlanningPortalGlobalStateModel>, { payload }: SetTenant) {
    ctx.setState({ ...ctx.getState(), tenant: payload });
  }

  @Action(ValidateJobTerminals)
  ValidateJobTerminals(ctx: StateContext<PlanningPortalGlobalStateModel>, { payload }: ValidateJobTerminals) {
    ctx.setState({ ...ctx.getState(), validateJobTerminals: payload });
  }

  @Selector()
  static ValidateJobTerminals(state: PlanningPortalGlobalStateModel) {
    return state.validateJobTerminals;
  }
  @Selector()
  static GetTenant(state: PlanningPortalGlobalStateModel) {
    return state.tenant;
  }

  @Selector()
  static TenantId(state: PlanningPortalGlobalStateModel) {
    return state.tenantId;
  }

  @Selector()
  static Tenant(state: PlanningPortalGlobalStateModel) {
    return state.tenant;
  }

  @Selector()
  static ClientId(state: PlanningPortalGlobalStateModel) {
    return state.clientId;
  }

  @Selector()
  static OrganizationUnitId(state: PlanningPortalGlobalStateModel) {
    return state.organizationUnitId;
  }

  @Selector()
  static ConnectionId(state: PlanningPortalGlobalStateModel) {
    return state.connectionId;
  }

  @Selector()
  static SubscriptionKeyInterceptor(state: PlanningPortalGlobalStateModel) {
    return state.subscriptionKeyInterceptor;
  }

  @Selector()
  static SelectedDistributionLane(state: PlanningPortalGlobalStateModel) {
    return state.selectedDistributionLane;
  }

  @Selector()
  static DistributionLaneId(state: PlanningPortalGlobalStateModel) {
    return state.distributionLaneId;
  }

  @Selector()
  static Authorize(state: PlanningPortalGlobalStateModel) {
    return state.authorize;
  }
}
